export const browserNotifications = {
  isSupported(): boolean {
    return 'Notification' in window;
  },

  async requestPermission(): Promise<boolean> {
    if (!this.isSupported()) return false;
    if (Notification.permission === 'granted') return true;
    if (Notification.permission === 'denied') return false;
    const result = await Notification.requestPermission();
    return result === 'granted';
  },

  isPermissionGranted(): boolean {
    return this.isSupported() && Notification.permission === 'granted';
  },

  show(
    title: string,
    options?: { body?: string; icon?: string; tag?: string; onClick?: () => void },
  ): Notification | null {
    if (!this.isPermissionGranted()) return null;
    const notification = new Notification(title, {
      body: options?.body,
      icon: options?.icon || '/praxis-logo.png',
      tag: options?.tag,
      silent: false,
    });
    if (options?.onClick) {
      notification.onclick = () => {
        window.focus();
        options.onClick?.();
        notification.close();
      };
    }
    return notification;
  },
};
